export default __webpack_public_path__ + "static/media/dattes.55a35d4a.jpg";